import isEmpty from 'is-empty';
import { event } from 'utils/gtag';
import { APP_ENVIRONMENT } from '@/utils/constants';

type Props = {
  userId: string;
  language: string;
  channel?: {
    _id: string;
    channel_type: string;
    name_en: string;
  };
  content: {
    _id: string;
    film_title: string;
    content_type: string;
  };
  playedHour: number;
};

type ViewRelojPageProps = {
  language: string;
};

type AppMarketClickProps = {
  language: string;
  appMarketUrl: string;
};

const siteMetadata = {
  brand: 'Butaca TV',
  endpoint_group: 'Desktop',
  subbrand: 'Butaca TV',
  endpoint: 'Butaca TV',
  platform: 'Web',
  environment: APP_ENVIRONMENT,
};

const dataLayer = (userId, language, content, playedHour) => {
  return {
    ...siteMetadata,
    user_id: userId,
    language,
    film_id: content._id,
    film_duration: content.runtime,
    film_genre: content.genre_en,
    film_director: content.director,
    film_name: content.film_title,
    film_type: content.content_type,
    played_hour: playedHour,
  };
};

const channelDataLayer = (userId, language, channel, content, playedHour) => {
  return {
    ...siteMetadata,
    user_id: userId,
    language,
    channel_id: channel._id,
    channel_type: channel.channel_type,
    channel_name: channel.name_en,
    film_id: content._id,
    film_name: content.film_title,
    film_veranda_id: content.veranda_ID,
    film_duration: content.runtime,
    film_type: content.content_type,
    asset_start_at: content.start,
    asset_end_at: content.end,
    played_hour: playedHour,
  };
};

const relojPageLayer = (language) => {
  return {
    ...siteMetadata,
    language,
  };
};

const appMarketLayer = (language, appMarketUrl) => {
  return {
    ...siteMetadata,
    language,
    app_market_url: appMarketUrl,
  };
};

const getUserId = (id) => (isEmpty(id) ? 'guest' : id);

export const sendVideoWatchDepth = ({
  userId,
  language,
  content,
  playedHour,
}: Props) => {
  console.log({
    event: 'movie_watch_depth',
    data: dataLayer(getUserId(userId), language, content, playedHour),
  });
  event({
    event: 'movie_watch_depth',
    data: dataLayer(getUserId(userId), language, content, playedHour),
  });
};

export const sendChannelWatchDepth = ({
  userId,
  language,
  channel,
  content,
  playedHour,
}: Props) => {
  console.log({
    event: 'channel_watch_depth',
    data: channelDataLayer(
      getUserId(userId),
      language,
      channel,
      content,
      playedHour,
    ),
  });
  event({
    event: 'channel_watch_depth',
    data: channelDataLayer(
      getUserId(userId),
      language,
      channel,
      content,
      playedHour,
    ),
  });
};

export const sendViewRelojPage = ({ language }: ViewRelojPageProps) => {
  console.log({
    event: 'view_reloj_page',
    data: relojPageLayer(language),
  });
  event({
    event: 'view_reloj_page',
    data: relojPageLayer(language),
  });
};

export const sendClickAppMarket = ({
  language,
  appMarketUrl,
}: AppMarketClickProps) => {
  console.log({
    event: 'click_app_market',
    data: appMarketLayer(language, appMarketUrl),
  });
  event({
    event: 'click_app_market',
    data: appMarketLayer(language, appMarketUrl),
  });
};
